export const initContactBanner = () => {
  const closeBtn = document.querySelector(
    '[data-page-contact-banner-close-icon]'
  );
  const banner = document.querySelector('[data-section="page-contact-banner"]');

  if (!closeBtn || !banner) return;

  closeBtn.addEventListener('click', () => {
    banner.setAttribute('data-show', 'false');
  });
};
